module.exports = __webpack_public_path__ + "assets/img/mecha-btn-4d3d3d4b.png";